import { render, staticRenderFns } from "./Game_TokenContent.vue?vue&type=template&id=7014165a&scoped=true&"
import script from "./Game_TokenContent.vue?vue&type=script&lang=js&"
export * from "./Game_TokenContent.vue?vue&type=script&lang=js&"
import style0 from "./Game_TokenContent.vue?vue&type=style&index=0&id=7014165a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7014165a",
  null
  
)

export default component.exports